const i18n = {
  'en-US': {
    'register.form.title': 'Create Account',
    'register.form.subTitle': 'Sign up to get started',
    'register.form.userName.errMsg': 'Username cannot be empty',
    'register.form.userName.minErrMsg': 'Username must be at least 4 characters',
    'register.form.userName.maxErrMsg': 'Username cannot exceed 20 characters',
    'register.form.userName.placeholder': 'Enter username',
    'register.form.email.errMsg': 'Email cannot be empty',
    'register.form.email.formatErrMsg': 'Please enter a valid email address',
    'register.form.email.placeholder': 'Enter email',
    'register.form.password.errMsg': 'Password cannot be empty',
    'register.form.password.minErrMsg': 'Password must be at least 6 characters',
    'register.form.password.formatErrMsg': 'Password must contain uppercase, lowercase letters and numbers',
    'register.form.password.placeholder': 'Enter password',
    'register.form.password_confirmation.errMsg': 'Please confirm your password',
    'register.form.password_confirmation.matchErrMsg': 'Passwords do not match',
    'register.form.password_confirmation.placeholder': 'Confirm password',
    'register.form.agreeTerms': 'I agree to the',
    'register.form.termsLink': 'Terms of Service',
    'register.form.agreeTerms.errMsg': 'Please agree to the Terms of Service',
    'register.form.register': 'Register',
    'register.form.haveAccount': 'Already have an account?',
    'register.form.loginLink': 'Sign in',
    'register.form.register.errMsg': 'Registration failed, please try again',
    'register.form.successMsg': 'Registration successful! Redirecting to login...'
  },
  'zh-CN': {
    'register.form.title': '创建账号',
    'register.form.subTitle': '注册以开始使用',
    'register.form.userName.errMsg': '用户名不能为空',
    'register.form.userName.minErrMsg': '用户名至少4个字符',
    'register.form.userName.maxErrMsg': '用户名不能超过20个字符',
    'register.form.userName.placeholder': '请输入用户名',
    'register.form.email.errMsg': '邮箱不能为空',
    'register.form.email.formatErrMsg': '请输入有效的邮箱地址',
    'register.form.email.placeholder': '请输入邮箱',
    'register.form.password.errMsg': '密码不能为空',
    'register.form.password.minErrMsg': '密码至少6个字符',
    'register.form.password.formatErrMsg': '密码必须包含大小写字母和数字',
    'register.form.password.placeholder': '请输入密码',
    'register.form.password_confirmation.errMsg': '请确认密码',
    'register.form.password_confirmation.matchErrMsg': '两次密码输入不一致',
    'register.form.password_confirmation.placeholder': '请确认密码',
    'register.form.agreeTerms': '我同意',
    'register.form.termsLink': '服务条款',
    'register.form.agreeTerms.errMsg': '请同意服务条款',
    'register.form.register': '注册',
    'register.form.haveAccount': '已有账号？',
    'register.form.loginLink': '去登录',
    'register.form.register.errMsg': '注册失败，请重试',
    'register.form.successMsg': '注册成功！正在跳转到登录页...'
  }
};
export default i18n;